import { Dictionary } from "lodash";
import { FilterValueMapper } from "Hooks/Tables/useTableFiltration";
import { isNoU } from "Utils/ObjectUtils";

export const booleanListItems = {
  none: "Vše",
  true: "Ano",
  false: "Ne",
} as Dictionary<string>;

export const getBooleanValue = (filterValue: string): boolean | undefined => {
  switch (filterValue) {
    case "none":
      return undefined;
    case "true":
      return true;
    case "false":
      return false;
  }

  return undefined;
};

export const booleanValueMapper: FilterValueMapper = {
  fromString: value => (value === "none" ? undefined : value === "true"),
  toString: value => (isNoU(value) ? "none" : value ? "true" : "false"),
};
